<div class="text-center flex flex-column justify-content-center h-screen">
  <div class="mb-0">
    <img class="m-auto max-w-15rem" src="assets/FP-logo.png" alt="Logo" />
  </div>
  <h1 class="text-5xl">Until next time! 👋</h1>
  <p class="text-xl">Your account has been deleted.</p>
</div>
